// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* Container around the phone input */
.custom-phone-input {
  width: 100%;
  margin-bottom: 24px;
}

/* Base PhoneInput styles */
.custom-phone-input .PhoneInput {
  display: flex !important;
  align-items: center;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 4px 12px;
  background: #fff;
  transition: all 0.2s ease;
  min-height: 52px;
}

.custom-phone-input .PhoneInput--focus {
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}

/* Country selector section */
.custom-phone-input .PhoneInputCountry {
  margin-right: 12px;
  padding: 4px 8px;
  border-right: 1px solid #f1f5f9;
  display: flex;
  align-items: center;
}

.custom-phone-input .PhoneInputCountrySelect {
  cursor: pointer;
}

/* Phone input field */
.custom-phone-input input.PhoneInputInput {
  flex: 1 1;
  border: none !important;
  outline: none !important;
  font-size: 16px;
  background: transparent;
  color: #1e293b;
  width: 100%;
}

.custom-phone-input input::placeholder {
  color: #94a3b8;
}

/* Error style if needed */
.custom-phone-input.has-error .PhoneInput {
  border-color: #ef4444;
}

.custom-phone-input.has-error .PhoneInput--focus {
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}

/* Error message styles */
.custom-phone-input-container .error {
  color: red;
  font-size: 12px;
  margin-top: 4px;
}

.blinking-dot {
  position: absolute;
  top: -4px;
  /* adjust to place above the icon */
  right: -2px;
  /* adjust to align */
  width: 8px;
  height: 8px;
  background-color: red;
  border-radius: 50%;
  animation: blink 1s infinite;
}

@keyframes blink {
  50% {
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,SAAO;EACP,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,yBAAyB;AACzB;EACE,UAAU;EACV,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,mCAAmC;EACnC,WAAW;EACX,oBAAoB;EACpB,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Container around the phone input */\n.custom-phone-input {\n  width: 100%;\n  margin-bottom: 24px;\n}\n\n/* Base PhoneInput styles */\n.custom-phone-input .PhoneInput {\n  display: flex !important;\n  align-items: center;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 4px 12px;\n  background: #fff;\n  transition: all 0.2s ease;\n  min-height: 52px;\n}\n\n.custom-phone-input .PhoneInput--focus {\n  border-color: #007bff;\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);\n}\n\n/* Country selector section */\n.custom-phone-input .PhoneInputCountry {\n  margin-right: 12px;\n  padding: 4px 8px;\n  border-right: 1px solid #f1f5f9;\n  display: flex;\n  align-items: center;\n}\n\n.custom-phone-input .PhoneInputCountrySelect {\n  cursor: pointer;\n}\n\n/* Phone input field */\n.custom-phone-input input.PhoneInputInput {\n  flex: 1;\n  border: none !important;\n  outline: none !important;\n  font-size: 16px;\n  background: transparent;\n  color: #1e293b;\n  width: 100%;\n}\n\n.custom-phone-input input::placeholder {\n  color: #94a3b8;\n}\n\n/* Error style if needed */\n.custom-phone-input.has-error .PhoneInput {\n  border-color: #ef4444;\n}\n\n.custom-phone-input.has-error .PhoneInput--focus {\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);\n}\n\n/* Error message styles */\n.custom-phone-input-container .error {\n  color: red;\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.blinking-dot {\n  position: absolute;\n  top: -4px;\n  /* adjust to place above the icon */\n  right: -2px;\n  /* adjust to align */\n  width: 8px;\n  height: 8px;\n  background-color: red;\n  border-radius: 50%;\n  animation: blink 1s infinite;\n}\n\n@keyframes blink {\n  50% {\n    opacity: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
